
/* injects from baggage-loader */

'use strict';

import utilitiesConstant from './constants/utilities.constant';
import navigationConstant from './constants/navigation.constants';
import userAccessConstant from './constants/userAccess.constants';
import loaderDirective from './directives/loader.directive';
import helperProvider from './services/routerHelper.provider';
import restClientFactory from './services/restClient.factory';
import sessionFactory from './services/session.factory';
import utilitiesFactory from './services/utilities.factory';
import interceptorFactory from './services/interceptor.factory'
import fullDateTimeMomentFilter from './filters/fullDateTimeMoment.filter';

/**
 * Shared module definition.
 */
const shared = angular.module('core.shared.module', []);

/**
 * Assign the components to shared module.
 */
utilitiesConstant(shared);
navigationConstant(shared);
userAccessConstant(shared);

helperProvider(shared);

restClientFactory(shared);
sessionFactory(shared);
utilitiesFactory(shared);
interceptorFactory(shared);

loaderDirective(shared);

fullDateTimeMomentFilter(shared);

export default shared;



// WEBPACK FOOTER //
// ./src/app/core/core.module.js